// source: design/src/pages/IoTRobotPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_ja';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-robot.png',
  heroTitle: 'ロボット',
  pageTitle: 'ロボットソリューション',
  heroSubtitle: 'Robotics Solutions',
  heroTagline: 'IoTとロボット技術を融合させ、企業の自動化の新時代を切り開く',
  corporatePartnerships: {
    title: '飛狼聚聯科技（上海）有限公司は雲深処科技の正式な認定A級代理',
    link: {
      label: '雲深処科技 公式サイト',
      path: 'https://www.deeprobotics.cn/en',
    },
  },
  intro: [
    'ロボットは「未来の技術」から、実際の現場へと徐々に浸透しつつあります。',
    '工場では、高頻度な巡回点検を人間に代わって行い、倉庫や物流の現場では、搬送や輸送の業務を担っています。また、高温・高所・狭隘（きょうあい）な場所やその他の危険な環境においても、人間にとって頼もしい作業のパートナーとなりつつあります。IoT、AI、ロボット技術の融合が進むにつれ、ロボットが担う役割は単なる単純反復作業にとどまらず、かつては人手に頼らざるを得なかった複雑なタスクへと拡大しています。',
    '中国のロボット産業は急速に発展しており、雲深処科技の産業用巡回点検ロボットに代表されるように、国産ロボットは性能、応用能力、コストの面ですでに高い国際競争力を備えています。',
    '飛狼は雲深処科技と提携し、ロボット技術と企業の実際の業務シナリオを融合させています。ロボットの選定、IoT接続、システムインテグレーションから現場への導入・運用保守に至るまで、企業が実際に活用できるロボットソリューションを構築します。私たちが目指すのは、単に「企業にロボットを導入する」ことではなく、ロボットを企業の業務運営に真に不可欠な一部として定着させることです。',
  ],
  scenarioTitle: '業界別活用シーン',
  scenarioTitleEn: 'Use Cases',
  scenarios: [
    {
      image: 'si/images/iot-scene-factory.png',
      title: '工場点検巡回',
      desc: '四足歩行ロボットが熱画像・ガスセンサーを搭載し、24時間自動で設備点検巡回を実施し、異常をリアルタイムにアラートします。適用シーン：変電所、化学工場区画、データセンター。',
    },
    {
      image: 'si/images/iot-scene-warehouse.png',
      title: '倉庫物流',
      desc: 'AGV/AMRが自動で搬送、仕分け、パレタイジングを行い、WMSシステムと連携して倉庫作業の全工程自動化を実現します。',
    },
    {
      image: 'si/images/iot-scene-hazard.png',
      title: '危険環境作業',
      desc: 'ロボットが作業者に代わって有毒、高温、放射線などの危険環境に入り、検出とサンプリングを行います。',
    },
    {
      image: 'si/images/iot-scene-construction.png',
      title: '建設現場モニタリング',
      desc: 'ドローンと地上ロボットが協働し、施工進度の監視、安全巡視、土量測定を実現します。',
    },
    {
      image: 'si/images/iot-scene-security.png',
      title: 'セキュリティ警備',
      desc: '自律警備ロボットが高精細カメラと暗視装置を搭載し、園区、倉庫、工場区画のインテリジェントセキュリティを実現します。',
    },
    {
      image: 'si/images/iot-scene-remote.png',
      title: 'リモート運用保守',
      desc: '5Gネットワークを通じてロボットのリモート操作とリアルタイムデータ転送を実現し、専門家が現場作業をリモートで指導します。',
    },
  ],
  matrixTitle: '製品ラインナップ',
  matrixTitleEn: 'Product Matrix',
  matrixHeadings: {
    type: '製品タイプ',
    mobility: '移動方式',
    payload: '積載能力',
    conn: '通信方式',
    usage: '主な用途',
  },
  matrixRows: [
    {
      type: '四足歩行ロボット',
      mobility: '高機動',
      payload: '中等',
      conn: '5G / WiFi',
      usage: '点検・救助',
    },
    {
      type: '輪式AMR',
      mobility: '中速',
      payload: '高',
      conn: 'WiFi / BLE',
      usage: '物流搬送',
    },
    {
      type: '協働ロボットアーム',
      mobility: '固定',
      payload: '可変',
      conn: 'OPC-UA / ROS',
      usage: '組立作業',
    },
    {
      type: 'ドローン(UAV)',
      mobility: '飛行',
      payload: '軽量',
      conn: '4G / 5G',
      usage: '航空点検',
    },
  ],
  note: '注：飛狼はソリューション・インテグレーターであり、ロボットのハードウェアを直接製造することはありません。Deep Robotics社のLite3/X30など、市場をリードする製品をベースに、お客様向けにカスタマイズされたロボットシステム・インテグレーション・サービスを提供しています。',
};
